import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import s from './OperationalSetupTabs.module.scss';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { IsWidgetAccessible } from '../../utils/widgetManager';

const Tab = ({ selectedPage, pageComponent, url, title }) => (
  <Fragment>
    <Link className={classNames({ [s.active]: selectedPage === pageComponent })} to={url}>
      {title}
      {selectedPage === pageComponent && <span />}
    </Link>
  </Fragment>
);

const OperationalSetupTabs = ({ selectedPage, userProfileWidgets }) => (
  <ul className={s.tabNav}>
    {IsWidgetAccessible(userProfileWidgets, 'MODELCATEGORY_TAB') && (
      <li>
        <Tab
          url={`/operational-setup/model-category-list`}
          title={<FormattedMessage id="OperationalSetupTabs.manageModelCategory" defaultMessage="Model Category" />}
          selectedPage={selectedPage}
          pageComponent="manageModelCategory"
        />
      </li>
    )}
    {IsWidgetAccessible(userProfileWidgets, 'TASKSCHECKLISTS_TAB') && (
      <li>
        <Tab
          url={`/operational-setup/checklist-task-templates`}
          title={<FormattedMessage id="OperationalSetupTabs.checklistsTasks" defaultMessage="Checklists & Tasks" />}
          selectedPage={selectedPage}
          pageComponent="checklistTaskTemplate"
        />
      </li>
    )}

  </ul>
);

OperationalSetupTabs.propTypes = {
  selectedPage: PropTypes.string.isRequired
};

export default OperationalSetupTabs;
